import { jsx as r } from "react/jsx-runtime";
import { HEADING_STYLES as a } from "../../../constants/default-styles.mjs";
import { TextLevelEnum as e } from "../text-level-enum.mjs";
const c = (n) => {
  const t = (i) => {
    switch (i) {
      case e.Default:
      default:
        return n("text_level.paragraph");
      case e.H2:
        return n("text_level.header_one");
      case e.H3:
        return n("text_level.header_two");
      case e.H4:
        return n("text_level.header_three");
    }
  };
  return [
    {
      id: e.Default,
      caption: t(e.Default),
      customCaption: /* @__PURE__ */ r("div", { children: t(e.Default) })
    },
    {
      id: e.H2,
      caption: t(e.H2),
      customCaption: /* @__PURE__ */ r("div", { style: { fontSize: a[e.H2].fontSize }, className: "font-bold", children: t(e.H2) })
    },
    {
      id: e.H3,
      caption: t(e.H3),
      customCaption: /* @__PURE__ */ r("div", { style: { fontSize: a[e.H3].fontSize }, className: "font-bold", children: t(e.H3) })
    },
    {
      id: e.H4,
      caption: t(e.H4),
      customCaption: /* @__PURE__ */ r(
        "div",
        {
          style: { fontSize: a[e.H4].fontSize },
          className: "font-semibold",
          children: t(e.H4)
        }
      )
    }
  ];
}, u = (n) => {
  if (!n) return;
  const t = n.getAttributes("heading");
  if (t.level)
    switch (t.level) {
      case 2:
        return e.H2;
      case 3:
        return e.H3;
      case 4:
        return e.H4;
    }
  return e.Default;
};
export {
  u as getCurrentTextLevelValue,
  c as getTextLevelValues
};
